import $ from 'jquery';

import webApp from './webApp';

const networkStatusCheck = {
  isOnline: true,

  init() {
    // Update isOnline by checking the results of AJAX requests. 
    // We do this instead of using navigator.onLine, as navigator.onLine is 
    // not implemented consistently across desktop browsers, and only tells 
    // us if we have a connection to a router, not the Internet.
    $( document ).ajaxSuccess( function( event, jqXhr, ajaxOpts, data ) {
      if ( jqXhr.status == 200 ) {
        webApp.networkStatus = true;
      }
    } );

    function onSuccess( data, textStatus, jqXhr ) {
      if ( jqXhr.status == 200 ) {
        webApp.networkStatus = true;
      }
    }

    function onFail() {
      webApp.networkStatus = false;
    }

    function sendConnectivityTestRequest() {
      $.ajax( { type: 'HEAD', url: webApp.env.plugin_url +'/version.txt', cache: false, timeout: 20000 } ).
        done( onSuccess ).
        fail( onFail );
    }

    var pageChangeTestRequestTimeout;

    /**
     * If we're offline, the reader is not necessarily making any HTTP 
     * requests when changing issue page. For isOnline to update we must try to
     * do an HTTP request.
     *
     * When online, we'll want to check if we've gone offline as often as
     * possible. Making test requests to the server in a tight interval all the
     * the time (e.g. with window.setInterval) is not wise, so we'll instead
     * hook into the reader_page_index_changed event to make test requests, so that we're
     * only checking connectivity when we know the user is being active.
     */
    webApp.hooks.addAction( 'reader_page_index_changed', 'asmag_web_app', function() {
      // Don't thrash the server with requests when user changes pages quickly
      window.clearTimeout( pageChangeTestRequestTimeout );
      pageChangeTestRequestTimeout = window.setTimeout( sendConnectivityTestRequest, 3000 );
    } );

    /**
     * Extra connectivity check for when we're online. Polls the server in a 
     * _long_ interval to see if we've gone offline while reading an issue. This
     * is here because the user might be reading a page, and hasn't changed the
     * page in a long while (i.e. the reader_page_index_changed handler above hasn't been
     * run).
     */
    window.setInterval( function() {
      if ( this.isOnline ) {
        sendConnectivityTestRequest();
      }
    }, 60000 );

    // Initial connectivity check
    sendConnectivityTestRequest();
  }
};

export default networkStatusCheck;
